import { setMessage } from '../redux/actions/message';
import { saveRequestToken } from '../redux/actions/shared';
import { getAproxUserGeolocation } from '../redux/actions/base';

import { envSetting } from '../constants/envSetting';
import { endpoints } from '../constants/endpoints';
import {
  isUndefinedNull,
  trimLowerCase
} from '../helpers/shared';
import { getDevice } from '../helpers/geolocation';
import { getRequest, handleRequest, postFileRequest } from '../helpers/request';
import { store } from '../redux/store/store';
import { BASE_DEVICE_INFO } from '../redux/types/base';
import i18n from '../translations/i18n';
import { we_api } from '../redux/services/services';

/**
 * Call request for save user file
 * @param {String} userIdBifrost
 * @param {Object} payload
 * @param {Boolean} isImagesFull
 * @returns
 */
export const saveUserFile = async (userIdBifrost, payload, isImagesFull) => {
  try {
    const endpoint = endpoints.saveUserFileFull(userIdBifrost)
    const response = await postFileRequest(endpoint, payload, true);
    return response;
  } catch (error) {
    console.error('saveUserFile: ', error);
  }
};

/**
 * Call request for save user file
 * @param {Object} payload
 * @returns
 */
export const downloadFile = async payload => {
  try {
    const response = await getRequest(endpoints.downloadFile(payload), '', true);
    return response;
  } catch (error) {
    console.error('downloadFile: ', error);
  }
};

/**
 * Call request for get request token
 * @returns
 */
export const getRequestToken = async () => {
  try {
    let { geolocation, deviceInfo } = store.getState().base;

    // Commented call to 'getUserGeolocation'
    if (isUndefinedNull(geolocation)) {
      const responseGeolocation = await store.dispatch(getAproxUserGeolocation())
    }

    if (isUndefinedNull(deviceInfo)) {
      const responseDevice = await getDevice();
      store.dispatch(handleRequest(responseDevice));
      if (responseDevice && !responseDevice.error) {
        deviceInfo = responseDevice;
        store.dispatch({ type: BASE_DEVICE_INFO, payload: deviceInfo });
      }
    }
    
    const result = await store.dispatch(we_api.endpoints.getLoginToken.initiate({
      username: envSetting.apiUser,
      password: envSetting.apiPassword
    }));

    if (result && !result.data.error && result.data.success) {
      saveRequestToken(result.data.success.token);
      return result.data.success.token;
    }
    return;
  } catch (error) {
    console.error('getRequestToken: ', error);
    store.dispatch(setMessage(i18n.t("message.errorRequestToken"), 'error'));
    return;
  }
};